import { Minus, Plus } from "lucide-react";
import type { FC } from "react";

import { cn } from "@/lib/utils";

import { formatHours } from "../utils";

type Props = {
  value: number;
  onChange: (hours: number) => void;
  /** Tenths by default; the server snaps to the firm's rounding. */
  step?: number;
  locked?: boolean;
  className?: string;
};

const round = (n: number) => Math.round(n * 100) / 100;

export const HoursStepper: FC<Props> = ({
  value,
  onChange,
  step = 0.1,
  locked,
  className
}) => (
  <span
    data-testid="hours-stepper"
    className={cn(
      "inline-flex h-7 items-center overflow-hidden rounded-lg border border-line-2 bg-surface",
      className
    )}
  >
    {locked ? null : (
      <button
        type="button"
        aria-label="Less time"
        className="inline-flex h-full w-6 items-center justify-center text-fg-3 hover:bg-fill-2 disabled:opacity-40"
        disabled={value <= step}
        onClick={(e) => {
          e.stopPropagation();
          onChange(Math.max(step, round(value - step)));
        }}
      >
        <Minus className="size-3" />
      </button>
    )}
    <span
      className={cn(
        "min-w-11 text-center text-base font-medium tabular-nums",
        locked && "px-2.5"
      )}
    >
      {formatHours(value)}
    </span>
    {locked ? null : (
      <button
        type="button"
        aria-label="More time"
        className="inline-flex h-full w-6 items-center justify-center text-fg-3 hover:bg-fill-2"
        onClick={(e) => {
          e.stopPropagation();
          onChange(round(value + step));
        }}
      >
        <Plus className="size-3" />
      </button>
    )}
  </span>
);
